window.Parsley
    .addValidator('fileextension', function (value, requirement) {
    if (!value)
        return false; // Ensure a file is provided
    var allowedExtensions = requirement.split(','); // Convert requirement into an array
    var fileExtension = value.split('.').pop().toLowerCase(); // Get the file extension
    return allowedExtensions.includes(fileExtension); // Check if extension is allowed
}, 32)
    .addMessage('en', 'fileextension', 'The file type is not supported. Allowed formats: PDF, DOC, DOCX');
window.Parsley
    .addValidator('maxFileSize', {
    validateString: function (value, maxSize, parsleyInstance) {
        if (!window.FormData) {
            alert('You are making all developpers in the world cringe. Upgrade your browser!');
            return true;
        }
        var files = parsleyInstance.$element[0].files;
        return files.length != 1 || files[0].size <= maxSize * 1024;
    },
    requirementType: 'integer',
    messages: {
        en: 'This file should not be larger than %s Kb',
    }
});
